//
//
//
//
//
//
//
//
//
//
//
//
//

import Card from './_card'
export default {
    props: {
        building_id: [String, Number],
        items: Array
    },
    components: {
        Card
    },
    methods: {
        goHouseInfo() {
            wx.navigateTo({
                url: `/building/info?id=''&building_id=${this.building_id || ''}`
            })
        }
    }
}
